import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {
    IVoceCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetVoceCostoDetail = (pk: number | undefined): UseQueryResult<IVoceCosto, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IVoceCosto> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/voci_costo/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetVoceCostoDetail", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetVoceCostoDetail